import api from './api';

// AWS cost reporting. `month` is YYYY-MM-01 (one whole month); `months` counts whole months back from the current one.
const q = (params) => ({ params: Object.fromEntries(Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== '')) });

export const reportingCostAPI = {
  months: () => api.get('/reporting/cost/months'),
  summary: (month, months) => api.get('/reporting/cost/summary', q({ month, months })),
  customers: (month, months) => api.get('/reporting/cost/customers', q({ month, months })),
  customer: (code, months = 6) => api.get(`/reporting/cost/customers/${encodeURIComponent(code)}`, q({ months })),
  regionTrend: (code, months = 12) => api.get(`/reporting/cost/customers/${encodeURIComponent(code)}/region-trend`, q({ months })),
  trend: (months = 12) => api.get('/reporting/cost/trend', q({ months })),
  accountSummary: (month) => api.get('/reporting/cost/account/summary', q({ month })),
  accountAll: (month) => api.get('/reporting/cost/account/all', q({ month })),
  untaggedServices: (month) => api.get('/reporting/cost/untagged/services', q({ month })),
  untaggedRegions: (month) => api.get('/reporting/cost/untagged/regions', q({ month })),
  exportCsv: (month) => api.get('/reporting/cost/export', { ...q({ month }), responseType: 'blob' }),
};
